import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IBuildTest, ICreateBuildDelivery } from "../interfaces";

interface IInitState {
  loading: boolean;
  data: IBuildTest[];
  error: string;
  filtersData: any;
  mutualError?:any;
  showDilogue?: boolean,
}

const initialState = {
  loading: false,
  data: [],
  error: "",
  filtersData: '',
  mutualError:{},
  showDilogue: false,
};

const createbuildDeliverySlice = createSlice({
  name: "createBuildDelivery",
  initialState,
  reducers: {
    createBuildDeliveryRequest(
      state: IInitState,
      action: PayloadAction<ICreateBuildDelivery>
    ) {
      state.loading = true;
      state.filtersData = action.payload
    },
    createBuildDeliverySuccess(
      state: IInitState,
      action: PayloadAction<any[]>
    ) {
      state.loading = false;
      state.data = action.payload;
      state.mutualError = {}
      state.showDilogue= false
    },
    createBuildDeliveryFailure(  
      state: IInitState,
      action: PayloadAction<any[]>)
      {
      state.loading = false;
      state.mutualError = action.payload;
      state.showDilogue= true;
    },
    createBuildClearMutualError(  state: IInitState,){
      state.mutualError = {};
      state.showDilogue= false;
      state.loading = false;
    }
  },
});

export const {
  createBuildDeliveryRequest,
  createBuildDeliverySuccess,
  createBuildDeliveryFailure,
  createBuildClearMutualError,
} = createbuildDeliverySlice.actions;
export default createbuildDeliverySlice.reducer;
